import homepage from './homepage';
import avatamsaka from './avatamsaka';

export default {
  homepage, avatamsaka,
};



// WEBPACK FOOTER //
// ./src/i18n/langs/tw/index.js